module.exports = __webpack_public_path__ + "static/media/galerija_2016 (7).91f40d33.jpg";